import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ErrorMessage from '../ErrorMessage';

const ColourGroup = ({
  options,
  defaultValue,
  onOptionChange,
  extraClass,
  customError,
  onCloseError,
  field,
  fieldState: { error },
}) => {
  const { name, value, onChange, ...fieldProps } = field;
  const [selectedColour, setSelectedColour] = useState(null);

  useEffect(() => {
    const option = options.find((option) => option.value === value);
    if (option) {
      setSelectedColour(option.img);
    } else {
      setSelectedColour(null);
    }
  }, [value]);

  return (
    <>
      <div className="form-label-wrapper preview-image">
        <div style={{ minHeight: 308 }}>
          {selectedColour !== null && (
            <img style={{ maxWidth: 500, maxHeight: 400 }} src={`/app/plugins/1-haircare-order-form/images/colours/${selectedColour}`} alt={value} />
          )}
        </div>
      </div>
      <div className={`form-cols form-col-colours ${extraClass ? extraClass : ''}`}>
        <div className="row g-3 justify-content-center">
          {options.length > 0 &&
            options.map((option, index) => (
              <div key={`${name}_${index}`} className="col-auto">
                <label
                  className={`btn-form-colour ${value === option.value ? 'active' : ''} ${option.disabled || false ? 'opacity-50' : ''}`}
                  htmlFor={`${name}_${index}`}
                >
                  <span className="swatch">
                    {option.hexcode ? (
                      <span className="swatch-inner" style={{ backgroundColor: option.hexcode }} />
                    ) : (
                      <span className="swatch-inner no-colour" />
                    )}
                  </span>
                  <span className="label">{option.value}</span>
                </label>
                <input
                  {...fieldProps}
                  name={name}
                  id={`${name}_${index}`}
                  className="btn-check"
                  type="radio"
                  value={option.value}
                  onChange={async () => {
                    const { value: newValue, disabled = false } = option;

                    await onOptionChange(option, disabled);

                    if (disabled) {
                      return;
                    }

                    onChange(newValue);

                    // fieldProps.onBlur();
                  }}
                  defaultChecked={
                    typeof defaultValue === 'string'
                      ? defaultValue === option.value
                      : defaultValue.includes(option.value)
                  }
                />
              </div>
            ))}
          {!customError && error && <ErrorMessage message={error.message} />}
        </div>
      </div>
      {!!customError && <ErrorMessage isModal onClose={onCloseError} message={customError} />}
    </>
  );
};

ColourGroup.propTypes = {
  field: PropTypes.shape().isRequired,
  fieldState: PropTypes.shape().isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      hexcode: PropTypes.string,
      imageSrc: PropTypes.string,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  onCloseError: PropTypes.func,
  customError: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  onOptionChange: PropTypes.func,
};

ColourGroup.defaultProps = {
  onOptionChange: () => {},
  onCloseError: () => {},
  customError: null,
};

export default ColourGroup;
